<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4 text-center">
        <div v-if="!error && !resultHash">
            <p>{{ $t('withdrawal.fromEmail.processing') }}</p>
            <p>{{ $t('withdrawal.fromEmail.wait') }}</p>
        </div>

        <div v-if="error">
            <p>{{ $t(error) }}</p>
        </div>

        <div v-if="resultHash">
            <p>{{ $t('withdrawal.fromEmail.success[0]') }}</p>
            <p>{{ $t('withdrawal.fromEmail.success[1]') }}</p>
        </div>

        <div class="text-center pt-3">
            <router-link to="/token/withdrawal" class="btn btn-outline-secondary" >
                {{ $t('withdrawal.fromEmail.goToWithdrawalBtn') }}
            </router-link>

            <router-link to="/token/history" class="btn btn-outline-secondary" >
                {{ $t('withdrawal.fromEmail.goHistoryBtn') }}
            </router-link>
        </div>
    </div>
</template>

<script>
    import tokenService from './../../services/TokenService';

    export default {
        name: 'TokenWithdrawalConfirmFromEmail',

        data() {
            return {
                error: '',
                resultHash: ''
            }
        },

        async mounted() {
            try {
                const data = (await tokenService.confirmWithdrawal(this.$route.query.token)).data;
                this.resultHash = data.hash;
            } catch (e) {
                this.error = e.response.data.message;
            }
        },

        methods: {}
    }
</script>

<style>

</style>
